import { Component, inject, OnInit }            from '@angular/core';
import { ActivatedRoute, Router }               from '@angular/router';
import { MatProgressSpinner }                   from '@angular/material/progress-spinner';
import { QrCodeComponent }                      from 'ng-qrcode';

import { InternalRoutes }        from '../../../../shared/data/internal-routes';
import { AuthenticationService } from '../../../../core/auth/authentication.service';
import { MfaOptions }            from '../../../../shared/data/mfa-options';
import { ButtonComponent }       from '../../../../shared/components/buttons/button.component';


@Component({
  selector: 'pin-set-mobile-app',
  templateUrl: './set-mobile-app.component.html',
  styleUrls: ['./set-mobile-app.component.scss'],
  imports: [QrCodeComponent, ButtonComponent, MatProgressSpinner]
})
export class SetMobileAppComponent implements OnInit {
  public returnUrl: string;
  public currentQueryParams = {};
  qrValue: string;
  secret: string;
  loadingQR = true;
  internalRoutes = InternalRoutes;
  private authService = inject(AuthenticationService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  ngOnInit() {
    const queryParamMap = this.route.snapshot.queryParamMap;
    this.returnUrl = queryParamMap.has('returnUrl') ? queryParamMap.get('returnUrl') : '/';

    this.currentQueryParams = {returnUrl: this.returnUrl};
    if (queryParamMap.has('overrideDisabledOption')) {
      this.currentQueryParams = {
        returnUrl: this.returnUrl,
        overrideDisabledOption: queryParamMap.get('overrideDisabledOption')
      };
    }

    this.authService.associateSoftwareToken().subscribe({
      next: result => {
        this.secret = result.secretCode;
        this.qrValue = result.qrValue;
        this.loadingQR = false;
      },
      error: () => {
        this.loadingQR = false;
      }
    });
  }

  continue() {
    this.router.navigate([InternalRoutes.ENTER_VERIFICATION_CODE], {
      queryParams: {
        mfaOption: MfaOptions.software_token_mfa,
        setup: true,
        returnUrl: this.returnUrl,
      }, skipLocationChange: true
    }).then(() => {});
  }

  backToSetup() {
    this.router.navigate([InternalRoutes.SETUP_SECURITY_TOKEN], {queryParams: {returnUrl: this.returnUrl}});
  }
}
